<main class="container" style="min-height:700px !important;">
    <section class="row pt-3">
        <div class="col-12 d-flex text-white justify-content-center">
            <h4>Forecast Detalle en {{typeMoney}}</h4>
        </div>

        <div class="col-12 d-flex justify-content-between mt-3 text-white">
            <div class="d-flex align-items-center">

                        <form   class="needs-validation2 row mx-5 mt-4 mb-4"
                    action=""
                    method="get"
                    [formGroup]="formSearch"
                  > 

                  <div class="col-2  d-flex flex-column">
                    <label for="formControlInput" class=" mx-1 form-label fw-bold">Inicio</label>
                    <input type="month"  formControlName="start_date" id="start_date" class="custom-outline-input ml-1 date" >
                  </div>

                  <div class="col-2  d-flex flex-column">
                    <label for="formControlInput" class=" ms-1 form-label fw-bold">Fin</label>
                    <input type="month"  formControlName="end_date" id="end_date" class="custom-outline-input mx-1 date" >
                  </div>

     

                    <div class="col-2  d-flex flex-column mt-2">
                        <label for="sucursal" class="form-label text-color">Tipo de pago </label>
            
                        <select class="mx-1 custom-outline-input form-select w-auto " aria-label="Default select" formControlName="optionTypePay">
                          <option value="0">Tipo de pago</option>
                          <option value="{{option.id}}" *ngFor="let option of listPlayOption">
                          {{option.name}}
                          </option>
                      </select>
                      </div>
            
            
                      <div class="col-2  d-flex flex-column mt-2">
                        <label for="sucursal" class="form-label text-color">Cliente </label>
                        <select  class="mx-1 custom-outline-input form-select w-auto" aria-label="Default select" formControlName="optionClient">
                          <option value="0">Cliente</option>
                          <option value="{{option.id}}" *ngFor="let option of listFilterClient">
                          {{option.name}}
                          </option>
                      </select>
                      </div>
            
                      <div class="col-2  d-flex flex-column mt-2">
                        <label for="sucursal" class="form-label text-color">Pais Operación</label>
                        <ng-multiselect-dropdown id="stado"  formControlName="selectOperation" class="flex-grow-1"
                        [placeholder]="'Pais Operación'"
                        [settings]="dropdownSettings"
                        [data]="filterOperation">
                      </ng-multiselect-dropdown>
                      </div>
            
                      <div class="col-2  d-flex flex-column mt-2">
                        <label for="sucursal" class="form-label text-color">Pais Venta Comercial </label>
                        <ng-multiselect-dropdown id="stado" formControlName="selectComercialOrigen" class="flex-grow-1"
                        [placeholder]="'Pais Venta Comercial'"
                        [settings]="dropdownSettings"
                        [data]="filterComercialOrigen">
                       >
                      </ng-multiselect-dropdown>
                      </div>
            
                      <!-- <div class="col-2  d-flex flex-column  mt-2">
                        <label for="sucursal" class="form-label text-color">Tipo de servicio </label>
                        <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="optionTypeService">
                            <option value="">Tipo de servicio</option>
                            <option value="{{option.id}}" *ngFor="let option of listTypeService">
                            {{option.name}}
                            </option>
                        </select>
                      </div> -->
            
                      <div class="col-2  d-flex flex-column  mt-2">
                        <label for="sucursal" class="form-label text-color">Conversor de moneda</label>
                        <select class="mx-1 custom-outline-input form-select flex-grow-1" aria-label="Default select" formControlName="currencyTransf">
                            <option value="0">Tipo de pago</option>
                            <option value="{{option.id}}" *ngFor="let option of listPlayOption">
                            {{option.name}}
                            </option>
                        </select>
                      </div>


                      <div class="col-8 d-flex justify-content-end bd-highlight ">
                        <div class="col-2 me-1 align-self-end bd-highlight">
                            <div class="d-flex justify-content-center align-items-center">
                                <button (click)="formSubmit()" type="submit"  class="btn btn-outline-light flex-grow-1">Buscar</button>
                            </div>
                        </div>
            
            
            
                      <div class="col-2 me-1 align-self-end bd-highlight">
                          <div class="d-flex justify-content-center align-items-center">
                            <button (click)="limpButton()" class="btn btn-outline-light">Limpiar</button>  
                          </div>
                      </div>
                      </div>
                   
                </form>
                
            </div>
        </div>
        <div class="col-12 mt-3 backgroundTable">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover  display nowrap componente-importantes componente-importantes-from-popup">
                    <ng-container *ngIf="listInfOption.length == 0">
                        <div class="text-center text-white">
                          <h2 class="text-white px-5 mt-5">Sin Registro</h2>
                          <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
                        </div>
                      </ng-container>
            
                      <ng-container *ngIf="listInfOption.length != 0">
                        <thead>
                            <tr>
                            <th class="text-white text-center">Cliente</th>

                            <ng-container *ngFor="let dato of listInfOption;index as i">
                                <th class="text-white text-center">{{dato.info}}</th>
                            </ng-container>
                    </thead>
                    <tbody>
                        
                        <tr *ngFor="let dato of listInfoPlay;index as i">

                            <td class="align-self-center p-2 bd-highlight">{{dato.name}}</td>
                       

                       

                            <ng-container *ngFor="let info of dato.listInfo;index as i">

                            <ng-container *ngIf="info.status == 0">
                                <td class="align-self-center p-2 bd-highlight">{{info.info}}</td>
                            </ng-container> 

                            <ng-container *ngIf="info.status == 1">
                                <td class="align-self-center p-2 bd-highlight text-success">{{info.info}}</td>
                            </ng-container> 

                            <ng-container *ngIf="info.status == 2">
                                <td class="align-self-center p-2 bd-highlight text-danger">{{info.info}}</td>
                            </ng-container> 

                            <ng-container *ngIf="info.status == 3">
                                <td class="align-self-center p-2 bd-highlight text-warning">{{info.info}}</td>
                            </ng-container> 

                            </ng-container>
                            
                    </tbody>
                </ng-container>
                 </table>
            </div>
    </section>
</main>